import { render, staticRenderFns } from "./PublicPage.vue?vue&type=template&id=73c0a25a&scoped=true"
import script from "./PublicPage.vue?vue&type=script&lang=js"
export * from "./PublicPage.vue?vue&type=script&lang=js"
import style0 from "./PublicPage.vue?vue&type=style&index=0&id=73c0a25a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0a25a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c0a25a')) {
      api.createRecord('73c0a25a', component.options)
    } else {
      api.reload('73c0a25a', component.options)
    }
    module.hot.accept("./PublicPage.vue?vue&type=template&id=73c0a25a&scoped=true", function () {
      api.rerender('73c0a25a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/allianceAuthorization/components/PublicPage.vue"
export default component.exports